<template>
    <b-list-group-item
        class="lista-menu"
        v-if="$temAcessoView('CRED-REL-001')"
        @click.stop="abrirModal()"
    >
        <span>RELAÇÃO GERAL DE CONTRATAÇÕES E ENTREGAS</span>
        <filtro
            ref="filtroModal"
            perfil="uabs"
            :servicos="obterRelatoriosServicos()"
            @filtrar="obterRelatorio($event)"
        ></filtro>
    </b-list-group-item>
</template>
<script>
import download from './../../../../shared/download'
import filtro from '../../relatorios/RelacaoContratacoesEntregasFiltro'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        },

        obterRelatorio(filtro) {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterRelatorio('001', filtro).then(
                (response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Falha ao obter relatório',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            download(
                                response,
                                `Relatorio_Geral_Contratacoes_Entregas.xlsx`
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterRelatoriosServicos() {
            return RelatoriosServicos
        }
    }
}
</script>
